// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1ehGv","col":"Table_col__3KS-i","fulfillmentStatus":"Table_fulfillmentStatus__27-pz","emailCol":"Table_emailCol__3nv6Y"};